import React, { useCallback, useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import './profile.scss';
import { Avatar, Popconfirm } from 'antd';
import inconAth from '../../assets/homme-tient-document-concept-contrat-removebg-preview.png';
import config from '../../config';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import NotificationPrefs from './NotificationPrefs';
import DataSaverPrefs from './DataSaverPrefs';
import {
    NdoePage,
    NdoePageHeader,
    NdoeFormSection,
    NdoeActionButton,
} from '../../components/ndoe';

const Profile = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [data, setData] = useState({});
    const { username, email, password } = data;
    const userId = useSelector((state) => state.user?.currentUser.id);
    const user = useSelector((state) => state.user.currentUser.username);

    const handleInputChange = (e) => {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;

        let updatedValue = fieldValue;

        if (fieldName === "contact_email") {
            updatedValue = fieldValue.toLowerCase();
        } else if (Number.isNaN(Number(fieldValue))) {
            updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
        }

        setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
    };

    // Récupère les infos du compte. Le champ mot de passe est volontairement laissé
    // vide (jamais prérempli avec le mot de passe existant) : on ne le renverra au
    // PUT que si l'utilisateur le saisit. Sert aussi de « refetch » réutilisable
    // après enregistrement et pour le bouton Annuler.
    const fetchData = useCallback(async () => {
        try {
            const { data } = await axios.get(`${DOMAIN}/api/user/getUserOne/${userId}`);
            setData({ ...(data[0] || {}), password: '' });
        } catch (error) {
            toast.error('Impossible de charger vos informations.');
        }
    }, [DOMAIN, userId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSave = async () => {
        try {
            // On n'envoie password que s'il est réellement saisi, sinon on ne
            // touche pas au mot de passe existant.
            const payload = { ...data };
            if (!payload.password || String(payload.password).trim() === '') {
                delete payload.password;
            }
            await axios.put(`${DOMAIN}/api/user/getUser/${userId}`, payload);
            toast.success('Vos informations ont été modifiées avec succès !');
            // Refetch au lieu de reload : rafraîchit l'affichage et revide le mot de passe.
            fetchData();
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message || 'Erreur lors de la modification.');
        }
    };

    return (
        <NdoePage>
            <NdoePageHeader
                eyebrow="Compte"
                title="Mettre à jour vos informations"
                subtitle="Modifiez vos identifiants de connexion"
            />

            <div className="profile">
                <div className="profile-wrapper">
                    <div className="profile-left">
                        <h2 className="profile2">Mon compte</h2>
                        <img src={inconAth} alt="" className="profile-img" />
                    </div>
                    <div className="profile-right">
                        <div className="profile-img-rows">
                            <h4 className="profile-h4">{user}</h4>
                            <div className="profile-info-rows">
                                <Avatar icon={<UserOutlined className='icon_ant' />} className='icon_ant' />
                            </div>
                        </div>

                        <NdoeFormSection
                            title="Informations du compte"
                            hint="Vos identifiants de connexion"
                            collapsible={false}
                        >
                            <div className="profile-bottom">
                                <div className="product-container-bottom">
                                    <div className="form-controle">
                                        <label htmlFor="">Nom <span style={{ color: 'red' }}>*</span></label>
                                        <input type="text" value={username || ''} className="form-input" name='username' onChange={handleInputChange} required />
                                    </div>
                                    <div className="form-controle">
                                        <label htmlFor="">Email <span style={{ color: 'red' }}>*</span></label>
                                        <input type="email" value={email || ''} className="form-input" name='email' onChange={handleInputChange} required />
                                    </div>
                                    <div className="form-controle">
                                        <label htmlFor="">Mot de passe</label>
                                        <input
                                            type="password"
                                            value={password || ''}
                                            className="form-input"
                                            name='password'
                                            placeholder="Laisser vide pour ne pas changer"
                                            autoComplete="new-password"
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-submit">
                                        <Popconfirm
                                            title="Confirmation"
                                            description="Êtes-vous sûr de vouloir modifier ces informations ?"
                                            okText="Confirmer"
                                            cancelText="Annuler"
                                            onConfirm={handleSave}
                                        >
                                            <NdoeActionButton variant="primary">Modifier</NdoeActionButton>
                                        </Popconfirm>
                                        <NdoeActionButton variant="secondary" onClick={fetchData}>Annuler</NdoeActionButton>
                                    </div>
                                </div>
                            </div>
                        </NdoeFormSection>
                    </div>
                </div>
            </div>

            {/* Mandat mobile §4 : préférences de notification par utilisateur. */}
            <NotificationPrefs />
            {/* Économie de données (16/07) : poids des photos, par utilisateur. */}
            <DataSaverPrefs />
        </NdoePage>
    );
}

export default Profile;
